import { axios } from '@/vue/utils/request'
const api = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  Test: '/test',
}

export function login(parameter) {
  return axios({
    url: api.Login,
    method: 'get',
    params: parameter
  })
}

